var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.contentType,{tag:"component",attrs:{"id":_vm.id,"hide-preview-button":_vm.hidePreviewButton},on:{"close":_vm.close}})}
var staticRenderFns = []

export { render, staticRenderFns }